import { render, staticRenderFns } from "./PromotionSimplePreview.vue?vue&type=template&id=8e31385e&"
import script from "./PromotionSimplePreview.vue?vue&type=script&lang=ts&"
export * from "./PromotionSimplePreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports